// extracted by mini-css-extract-plugin
export default {"main":"Imprint_main__G-KR+","iconsBeforeContent":"Imprint_iconsBeforeContent__O+zrP","imprintContent":"Imprint_imprintContent__ZftK+"};